import { defineStore } from 'pinia';
import { Session } from '/@/utils/storage';

import { useLoginApi, useUserApi } from '/@/api/user';
// 引入 api 请求接口
const { signOut } = useLoginApi();
const { getState, getInfo, getMessage } = useUserApi();

const useUserStore = defineStore('user', {
  state: () => ({
    isLogined: false,
    message: 0,
    userInfos: {},
    tagViews: [],
    hasAdminRole: false,
  }),
  actions: {
    getState() {
      return new Promise((resolve, reject) => {
        getState()
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getInfo() {
      return new Promise((resolve, reject) => {
        getInfo()
          .then((res) => {
            const { data, code, msg } = res;
            if (code !== -1) {
              this.getMessage();
              this.isLogined = true;
              this.userInfos = { ...data };
              this.hasAdminRole = data?.hasAdminRole;
            }
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getMessage() {
      return new Promise((resolve, reject) => {
        getMessage()
          .then((res) => {
            const { data, success } = res;
            success && (this.message = data >= 0 ? data : 0);
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 退出系统
    logOut() {
      return new Promise((resolve, reject) => {
        signOut()
          .then((res) => {
            // const { success } = res;
            // if (success) {
            // 	this.isLogined = false;
            // 	this.message = 0;
            // 	this.userInfos = {};
            // 	Cookies.remove("access_token");
            // }
            const { code, msg } = res;
            if (code === 0) {
              this.isLogined = false;
              this.message = 0;
              this.userInfos = {};
              Session.clear();
            }
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
});

export default useUserStore;
